import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-rings',
  templateUrl: './loading-rings.component.html',
  styleUrls: ['./loading-rings.component.scss']
})
export class LoadingRingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
